export const getChar = (letter,lw,rat) => {

		let l = {
			x:0.5*lw,
			y:0.5*lw/rat
		};

		let min = {
			w:0.1,
			h:0.1
		};

		if (l.x > min.w) {min.w = l.x;}
		if (l.y > min.y) {min.y = l.y;}

		switch (letter) {
			case '•':
			return {
					coords:[
						// [[0.2,0.5],[0.8,0.5]],
						// [[0.5,0.2],[0.5,0.8]],
						// [[0.25,0.25],[(1-0.25),(1-0.25)]],
						// [[(1-0.25),0.25],[0.25,(1-0.25)]]

						// [[0,0.5],[1,0.5]],
						// [[0.5,0],[0.5,1]],
						// [[0.05,0.05],[(1-0.05),(1-0.05)]],
						// [[(1-0.05),0.05],[0.05,(1-0.05)]]

						// [[0,0.5],[1,0.5]],
						// [[0.5,0],[0.5,1]],

						// [[0.1,0.1],[0.9,0.9]],
						// [[0.9,0.1],[0.1,0.9]]

						[[0,0.5],[1,0.5]],
						[[0.5,0.1],[0.5,0.9]],
						
						[[0.15,0.15],[0.85,0.85]],
						[[0.85,0.15],[0.15,0.85]]
					]
				}
			break;
			case '↓':
			return {
					coords:[
						// straight arrow (long)
						[[0.5,0],[0.5,1-l.y]],	// center

						[[0.5,1],[0.25-l.x,0.75-l.y]],
						[[0.5,1],[0.75+l.x,0.75-l.y]]
					],
					kern: 0.5
				}
			break;
			case 'A':
				return {
					coords:[
						[[0,1],[0.5,0]],
						[[0.5,0],[1,1]],
						[[(0.23),0.5],[0.77,0.5]]
					],
					//kern: -l.x
				}
			break;
			case 'B':
				return {
					coords:[
						[[l.x,0],[l.x,1]], // |
						[[0,l.y],[0.75,l.y]],
						[[0,0.5],[1,0.5]], // -

						[[0.75-l.y,0],[1-l.y,0.5]],
						[[0,(1-l.y)],[1,(1-l.y)]],
						[[1-l.y,1],[1-l.y,0.5]]
					]
				}
			break;
			case 'C':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[l.x,0],[l.x,1]],
						[[0,(1-l.y)],[1,(1-l.y)]]
					]
				}
			break;
			case 'D':
				return {
					coords:[
						[[l.x,0],[l.x,1]], // |
						[[0,l.y],[0.75,l.y]],
						[[0.75-l.y,0],[1-l.y,0.5]],
						[[1-l.y,1],[1-l.y,0.5-l.y]],
						[[0,1-l.y],[1,1-l.y]]
					]
				}
			break;
			case 'E':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[0,l.y],[1,l.y]],
						[[0,0.5],[0.5,0.5]],
						[[0,(1-l.y)],[1,(1-l.y)]]
					]
				}
			break;
			case 'F':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[0,l.y],[1,l.y]],
						[[0,0.5],[0.5,0.5]]
					]
				}
			break;
			case 'G':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						
						[[l.x,0],[l.x,1]],
						[[0,1-l.y],[1,1-l.y]],
						[[1-l.x,0.5-l.y],[1-l.x,1]],
						[[0.5,0.5],[1,0.5]],
					]
				}
			break;
			case 'H':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[0,0.5],[1,0.5]],
						[[1-l.x,0],[1-l.x,1]],
					]
				}
			break;
			case 'I':
				return {
					coords:[
						 //[[1-l.x,0],[1-l.x,1]]		// right
						 //[[l.x,0],[l.x,1]]			// left 

						 [[0.5,0],[0.5,1]]				// center
					],
					kern: 0.5-l.x
				}
			break;
			case 'J':
				return {
					coords:[
						[[0,1-l.y],[1,1-l.y]],
						[[1-l.x,0],[1-l.x,1]],
					]
				}
			break;
			case 'K':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[1,0],[0,0.5]],
						[[1,1],[0,0.5]],
					]
				}
			break;
			case 'L':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[0,1-l.y],[1,1-l.y]]
					]
				}
			break;
			case 'M':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[0,0],[0.5,0.5]],
						[[1,0],[0.5,0.5]],
						[[1-l.x,0],[1-l.x,1]],
					]
				}
			break;
			case 'N':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[0,0],[1,1]],
						[[1-l.x,0],[1-l.x,1]]
					]
				}
			break;
			case 'O':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[l.x,0],[l.x,1]],
						[[0,1-l.y],[1,1-l.y]],
						[[1-l.x,0],[1-l.x,1]],
					]
				}
			break;
			case 'P':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[0,l.y],[1,l.y]],
						[[1-l.x,0],[1-l.x,0.5+l.y]],
						[[0,0.5],[1,0.5]],
						
					]
				}
			break;
			case 'Q':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[l.x,0],[l.x,1]],
						[[0,1-l.y],[1,1-l.y]],
						[[1-l.x,0],[1-l.x,1]],

						[[0.7,0.7],[1,1]]
					]
				}
			break;
			case 'R':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[0,l.y],[1,l.y]],
						[[1-l.x,0],[1-l.x,0.5+l.y]],
						[[0,0.5],[1,0.5]],
						[[0.75,0.5],[1,1]]
					]
				}
			break;
			case 'S':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[l.x,0],[l.x,0.5+l.y]],
						[[0,0.5],[1,0.5]],
						[[1-l.x,0.5-l.y],[1-l.x,1]],
						[[0,(1-l.y)],[1,(1-l.y)]]
					]
				}
			break;
			case 'T':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[0.5,0],[0.5,1]]
					]
				}
			break;
			case 'U':
				return {
					coords:[
					[[l.x,0],[l.x,1]],
						[[0,1-l.y],[1,1-l.y]],
						
						[[1-l.x,0],[1-l.x,1]],
					]
				}
			break;
			case 'V':
				return {
					coords:[
						[[0,0],[0.5,1]],
						[[0.5,1],[1,0]],
					]
				}
			break;
			case 'W':
				return {
					coords:[
						[[0,0],[0.25,1]],
						[[0.25,1],[0.5,0.5]],
						[[0.5,0.5],[0.75,1]],
						[[1,0],[0.75,1]],
					],
					//kern: -l.x
				}
			break;
			case 'X':
				return {
					coords:[
						[[0,0],[1,1]],
						[[0,1],[1,0]],
					]
				}
			break;
			case 'Y':
				return {
					coords:[
						[[0.5,0.5],[0.5,1]],
						[[0,0],[0.5,0.5]],
						[[1,0],[0.5,0.5]]
					],
					//kern: -l.x
				}
			break;
			case 'Z':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[0,1],[1,0]],
						[[0,(1-l.y)],[1,(1-l.y)]]
					]
				}
			break;
			case '0':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[l.x,0],[l.x,1]],
						[[0,1-l.y],[1,1-l.y]],
						[[1-l.x,0],[1-l.x,1]],
					]
				}
			break;
			case '1':
				return {
					coords:[
						// [[1-l.x,0],[1-l.x,1]],
						// [[0.5,0.5],[1,0]],

						// [[0.5-l.x,0],[0.5-l.x,1]],
						// [[0,0.5],[0.5,0]],

						// [[0.5,0],[0.5,1]],
						// [[l.x,0.5],[0.5+l.x,0]],


						[[0.75-l.x,0],[0.75-l.x,1]],
						[[0.25,0.5],[0.75,0]]
					],
					kern: 0.25-l.x
				}
			break;
			case '2':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[1-l.x,0],[1-l.x,0.5+l.y]],
						[[0,0.5],[1,0.5]],
						[[l.x,0.5-l.y],[l.x,1]],
						
						
						[[0,(1-l.y)],[1,(1-l.y)]]
					]
				}
			break;
			case '3':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[1-l.x,0],[1-l.x,1]],
						
						
						[[0,(1-l.y)],[1,(1-l.y)]],
						[[0,0.5],[1,0.5]],
					]
				}
			break;
			case '4':
				return {
					coords:[
						[[1-l.x,0],[1-l.x,1]],
						[[0,0.5],[1,0.5]],
						[[l.x,0],[l.x,0.5+l.y]],
					]
				}
			break;
			case '5':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[l.x,0],[l.x,0.5+l.y]],
						[[0,0.5],[1,0.5]],
						[[1-l.x,0.5-l.y],[1-l.x,1]],
						[[0,(1-l.y)],[1,(1-l.y)]]
					]
				}
			break;
			case '6':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						
						[[l.x,0],[l.x,1]],
						[[0,1-l.y],[1,1-l.y]],
						[[1-l.x,0.5-l.y],[1-l.x,1]],
						[[0,0.5],[1,0.5]],
					]
				}
			break;
			case '7':
				return {
					coords:[
						[[1-l.x,0],[1-l.x,1]],
						[[0,l.y],[1,l.y]]
					]
				}
			break;
			case '8':
				return {
					coords:[

						// [[0,l.y],[1,l.y]],
						// [[l.x,0],[l.x,1]],
						// [[0,1-l.y],[1,1-l.y]],
						// [[1-l.x,0],[1-l.x,1]],

						[[1-l.x,0],[1-l.x,1]],
						[[0,l.y],[1,l.y]],
						[[l.x,0],[l.x,1]],
						[[0,(1-l.y)],[1,(1-l.y)]],
						[[0,0.5],[1,0.5]],
						
						
					]
				}
			break;
			case '9':
				return {
					coords:[
						[[1-l.x,0],[1-l.x,1]],
						[[0,l.y],[1,l.y]],
						
						[[l.x,0],[l.x,0.5+l.y]],
						[[0,0.5],[1,0.5]],
					]
				}
			break;
			case '.':
				return {
					coords:[
						//[[1-l.x,1-2*l.y],[1-l.x,1]]		// right
						//[[l.x,1-2*l.y],[l.x,1]] 			// left

						[[0.5,1-2*l.y],[0.5,1]]				// center
					],
					kern: 0.5-l.x
					//kern: 0.75
				}
			break;
			case '?':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[1-l.x,0],[1-l.x,0.5+l.y]],
						[[0.5-l.x,0.5],[1,0.5]],
						[[0.5,0.5-l.y],[0.5,0.75]],
						[[0.5,1-2*l.y],[0.5,1]] // . in 'y'	
					]
				}
			break;
			case '!':
				return {
					coords:[
						 // [[1-l.x,0],[1-l.x,0.75]],	// right
						 // [[1-l.x,1-2*l.y],[1-l.x,1]],	

						//[[l.x,0],[l.x,0.75]],		// left
						//[[l.x,1-2*l.y],[l.x,1]],	

						[[0.5,0],[0.5,0.75]],	// center
						[[0.5,1-2*l.y],[0.5,1]],	

					],
					kern: 0.5-l.x
				}
			break;
			case ',':
				return {
					coords:[
						// [[1,1-l.y],[1-2*l.x,1+l.y]],		// right
						// [[2*l.x,1-l.y],[0,1+l.y]],			// left	

						//[[0.5+l.x,1-l.y],[0.5-l.x,1+l.y]]	// center
						//[[0.6,0.9],[0.4,1.1]]

						[[0.5+min.w,1-min.h],[0.5-min.w,1+min.h]]
						

					],
					kern: 0.5-l.x
				}
			break;
			case ';':
				return {
					coords:[
						// [[1-l.x,0.5-l.y],[1-l.x,0.5+l.y]], 
						// [[1,1-l.y],[1-2*l.x,1+l.y]]

						// lowered
						// [[l.x,0.5-l.y],[l.x,0.5+l.y]],
						// [[2*l.x,1-l.y],[0,1+l.y]]

						// [[l.x,0.25],[l.x,0.25+2*l.y]], // left
						// [[2*l.x,0.75],[0,0.75+2*l.y]],

						//[[0.5,0.25],[0.5,0.25+2*l.y]], // center
						//[[0.5+l.x,0.75],[0.5-l.x,0.75+2*l.y]]

						[[0.5,0.25],[0.5,0.25+2*l.y]], // center
						[[0.5+min.w,0.75],[0.5-min.w,0.75+2*min.h]]
					],
					kern: 0.5-l.x
				}
			break;
			case ':':
				return {
					coords:[
						// [[1-l.x,0.5-l.y],[1-l.x,0.5+l.y]], 
						// [[1-l.x,1-2*l.y],[1-l.x,1]]

						// [[l.x,0.25],[l.x,0.25+2*l.y]],
						// [[l.x,0.75-2*l.y],[l.x,0.75]],	// left

						[[0.5,0.25],[0.5,0.25+2*l.y]],	// center
						[[0.5,0.75-2*l.y],[0.5,0.75]],

						// [[0.5,0.25],[0.5,0.25+2*min.h]],	// center
						// [[0.5,0.75-2*min.h],[0.5,0.75]],

					],
					kern: 0.5-l.x
				}
			break;
			case '_':
				return {
					coords:[
						[[0,1-l.y],[1,1-l.y]]
					]
				}
			break;
			case '(':
				return {
					coords:[
						// [[1-2*l.x,0.25-l.y],[1-2*l.x,0.75+l.y]],
						// [[1,0],[0.7,0.25]],
						// [[1,1],[0.7,0.75]]

						// [[l.x,0.25-l.y],[l.x,0.75+l.y]],
						// [[0.3,0],[0,0.25]],
						// [[0.3,1],[0,0.75]],

						
						[[0.7,0],[0.4,0.25]],
						[[0.4+l.x,0.25-l.y],[0.4+l.x,0.75+l.y]],
						[[0.7,1],[0.4,0.75]]
					],
					kern: 0.25-l.x
				}
			break;
			case ')':
				return {
					coords:[
						// [[1-l.x,0.25-l.y],[1-l.x,0.75+l.y]],
						// [[1,0.25],[0.7,0]],
						// [[1,0.75],[0.7,1]]

						// [[1-l.x,0.25-l.y],[1-l.x,0.75+l.y]],
						// [[1,0.25],[0.7,0]],
						// [[1,0.75],[0.7,1]],

						
						[[0.6,0.25],[0.3,0]],
						[[0.6-l.x,0.25-l.y],[0.6-l.x,0.75+l.y]],
						[[0.6,0.75],[0.3,1]]
					],
					kern: 0.25-l.x
				}
			break;
			case '\'':
				return {
					coords:[
						//[[1,0],[1-2*l.x,2*l.y]]
						//[[2*l.x,0],[0,2*l.y]]

						//[[0.5+l.x,0],[0.5-l.x,2*l.y]]

						[[0.5+min.w,0],[0.5-min.w,2*min.h]]
					],
					kern: 0.5-2*l.x
				}
			break; // ie: "aunt’s" instead of "aunt's"
			case '’':
				return {
					coords:[
						[[0.5+min.w,0],[0.5-min.w,2*min.h]]
					],
					kern: 0.5-2*l.x
				}
			break;
			case '/':
				return {
					coords:[
						//[[0.5,1],[1,0]]
						[[0.25,1],[0.75,0]]
					]
				}
			break;
			case '\\':
				return {
					coords:[
						//[[0.5,0],[1,1]]
						[[0.25,0],[0.75,1]]
					]
				}
			break;
			case '-':
				return {
					coords:[
						[[0.25-l.x,0.5],[0.75+l.x,0.5]]
					]
				}
			break;
			case '=':
				return {
					coords:[
						[[0.25-l.x,0.25+l.y],[0.75+l.x,0.25+l.y]],
						[[0.25-l.x,0.75-l.y],[0.75+l.x,0.75-l.y]]
					]
				}
			break;
			case '+':
				return {
					coords:[
						[[0.25-l.x,0.5],[0.75+l.x,0.5]],
						[[0.5,0.25],[0.5,0.75]]
					]
				}
			break;
			case '÷':
				return {
					coords:[
						[[0.25-l.x,0.5],[0.75+l.x,0.5]],
						
						[[0.5,0.25],[0.5,0.25+2*l.y]], 
						[[0.5,0.75],[0.5,0.75-2*l.y]], 
					]
				}
			break;
			case '*':
				return {
					coords:[
						[[0.25-l.x,0.5],[0.75+l.x,0.5]],
						[[0.5,0.25-0.5*l.x],[0.5,0.75+0.5*l.x]],

						[[0.25,0.25],[0.75,0.75]],
						[[0.75,0.25],[0.25,0.75]]
					]
				}
			break;
			case '%':
				return {
					coords:[
						[[0,1],[1,0]],
						[[l.x,2*l.y],[l.x,0]],
						[[1-l.x,1-2*l.y],[1-l.x,1]],
					]
				}
			break;
			case '$':
				return {
					coords:[
						[[0,l.y],[1,l.y]],
						[[l.x,0],[l.x,0.5+l.y]],
						[[0,0.5],[1,0.5]],
						[[1-l.x,0.5-l.y],[1-l.x,1]],
						[[0,(1-l.y)],[1,(1-l.y)]],

						[[0.5,0],[0.5,1]]
					]
				}
			break;
			case '#':
				return {
					coords:[
						[[0.25,0],[0.25,1]],
						[[0.75,0],[0.75,1]],
						
						[[0,0.25],[1,0.25]],
						[[0,0.75],[1,0.75]],
					]
				}
			break;
			case '@':
				return {
					coords:[
						[[l.x,0],[l.x,1]],
						[[0,l.y],[1,l.y]],
						[[1-l.x,0],[1-l.x,1]],

						[[1,1-l.y],[0.5,1-l.y]],
						[[0.5+l.x,1],[0.5+l.x,0.5]],
						[[0.5,0.5+l.y],[1,0.5+l.y]]
					]
				}
			break;
			case '<':
				return {
					coords:[
						[[0.25,0.5],[0.75,0.25]],
						[[0.25,0.5],[0.75,0.75]],
					]
				}
			break;
			case '>':
				return {
					coords:[
						[[0.75,0.5],[0.25,0.25]],
						[[0.75,0.5],[0.25,0.75]],
					]
				}
			break;
			case '^':
				return {
					coords:[
						[[0.5,0],[0.25-l.x,0.25+l.y]],
						[[0.5,0],[0.75+l.x,0.25+l.y]],
					]
				}
			break;
			case '"':
				return {
					coords:[
						// [[1-l.x,0],[1-l.x,0.25]],
						// [[0.75-l.x,0],[0.75-l.x,0.25]]

						 // [[l.x,0],[l.x,0.25]],
						 // [[0.25+l.x,0],[0.25+l.x,0.25]]

						[[0.25+l.x,0],[0.25+l.x,0.25]],
						[[0.75-l.x,0],[0.75-l.x,0.25]]
					],
					kern: 0.25
				}
			break;
			case '&':
				return {
					coords:[
						[[0.25,0.25],[1,1]],
						[[0.25,0.25+l.y],[0.25,0]],
						[[0.25-l.x,l.y],[0.75,l.y]],

						[[0.75,l.y],[l.x,0.5]],
						[[l.x,0.5-l.y],[l.x,1]],

						[[0,1-l.y],[0.75,1-l.y]],
						[[0.75-l.x,1-l.y],[1-l.x,0.75]],
					]
				}
			break;
			default:
				return {
					coords:[
						[[0.25,0.25-l.y],[0.25,0.75+l.y]],
						[[0.75,0.25-l.y],[0.75,0.75+l.y]],
						
						[[0.25-l.x,0.25],[0.75+l.y,0.25]],
						[[0.25-l.x,0.75],[0.75+l.y,0.75]],
					]
				}
		}
	}